// router.js
import Vue from 'vue'
import Router from 'vue-router'
import AppMain from './views/AppMain.vue'

Vue.use(Router)

const router = new Router({
  mode: 'history',
  routes: [
    {
      path: '/',
      name: 'index',
      component: AppMain
    },
    {
      path: '/recharge-vip',
      name: 'recharge-vip',
      component: () => import('./views/recharge_vip/RechargeVip.vue')
    },
    // {
    //   path: '/resetPass',
    //   component: () => import('./components/ResetPass.vue')
    // }
  ]
})

export default router
